import { useAuth } from '~/hooks/useAuth'

/**
 * Whether the signed-in user has the read-only access level. Read-only users keep their
 * role's visibility but lose every write action; some areas (e.g. billing, whose backend
 * has no read-only access level) are denied entirely rather than partially gated.
 */
export default function useIsReadOnly() {
  const { user } = useAuth()
  return Boolean(user?.readOnly)
}
